<template>
  <ObNav
    :style="{
      backgroundColor: `${backgroundColor}`,
    }"
    :top="top"
    :zIndex="zIndex"
  >
    <template #left>
      <slot name="left">
        <div class="navigation-left">
          <svg-icon @click="onClickLeft" name="icon-back" :color="iconColor" />
          <span class="navigation-title"
            :style="{
              color: iconColor
            }"
          >{{ title || route.meta.pageName || navigationTitle }}</span>
        </div>
      </slot>
    </template>
    <template #right>
      <slot name="right">
        <SvgIcon v-if="share" name="icon-share" @click.stop="showShare = true"/>
      </slot>
    </template>
  </ObNav>
  <WapShare 
    v-model="showShare"
    :bindUrl="shareUrl"
  />
</template>

<script>
import setRootCssProperties from '@/utils/setRootCssProperty'

import { storeToRefs } from 'pinia';
import { useSystemStore } from '@/stores/system' 
import { useNavigationStore } from '@/stores/navigation'

export default {
  name: 'WapHead',
  props: {
    leftCallBack: {
      type: Function,
      defautl: null
    },
    backgroundColor: {
      type: String,
      default: 'var(--color-background-primary)'
    },
    iconColor: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    top: {
      type: String,
      default: 'var(--orbit-notice-height, 0px)',
    },
    share: {
      type: Boolean,
      default: false
    },
    navColor: {
      type: String,
      default: 'var(--color-text-primary)',
    },
    zIndex: {
      type: [String, Number]
    }
  },
  setup (props) {
    const route = useRoute()
    const router = useRouter()
    const systemStore = useSystemStore()
    const navigationStore = useNavigationStore()
    const { isApp } = storeToRefs(systemStore)
    const { navigationTitle } = storeToRefs(navigationStore)
    const { proxy } = getCurrentInstance()

    const { iconColor, top, backgroundColor } = toRefs(props)

    const shareUrl = ref(location.href)
    const showShare = ref(false)

    setRootCssProperties({
      '--orbit-nav-height': '50px'
    })

    function onClickLeft () {
      if (props.leftCallBack) {
        props.leftCallBack()
        return false
      }
      if (isApp.value || location.href.includes('fromUserCenter') || location.href.includes('isHideToolbar') || location.href.includes('storeapp')) {
        if (!router.options.history.state.back) {
          proxy.$goBack()
        } else {
          router.back();
        }
        return
      } 
      if (!router.options.history.state.back) {
        location.href = location.origin
      } else {
        router.back();
      }
    }
    watch(route, () => {
      navigationStore.setNavigationHeight(+50)
      setRootCssProperties({
        '--orbit-nav-height': '50px'
      })
      shareUrl.value = location.href
    }, {
      immediate: true,
      deep: true
    })

    return {
      top,
      route,
      shareUrl,
      showShare,
      iconColor,
      backgroundColor,
      navigationTitle,
      onClickLeft,
    }
  },
}
</script>
<style lang="postcss" scoped>
.navigation-left {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  .navigation-title {
    font-size: 16px;
    font-family: 'orbit-M';
    margin-left: 16px;
  }
}
  
</style>